<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>
           
            <TicketComp />
        </v-main>
    </v-app>
  </template>
  <script>
  import Auth from '@/services/auth.service.js'
  import TicketComp from '@/components/tickets/TicketComp.vue'
  
  export default {
    components: {
        TicketComp,
    },
    data() {
        return {
        };
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        document.title = 'פנייה | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
    },
  }
  </script>
  <style>
  
  </style>